import { Injectable, Optional } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { EnvironmentConfig } from '../services/config';

@Injectable({
  providedIn: 'root'
})
export class UrlInterceptor implements HttpInterceptor {

  /**
 * Creates an instance of the CacheInterceptor which @implements the class HttpInterceptor
 *
 * @param {EnvironmentConfig} config Injected instance of EnvirontmentConfig
 */
  constructor(@Optional() private config: EnvironmentConfig) { }

  /**
   * Intercepts and prepends api(base url) from EnvirontmentConfig if request does not begin with http:// or https://
   * @param req — The outgoing request object to handle.
   * @param next
   * The next interceptor in the chain, or the backend if no interceptors remain in the chain.
   *@returns — An observable of the event stream.
  */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!/^http/.test(req.url)) {
      const request = req.clone({
        url: this.config.api + req.url
      });
      return next.handle(request);
    }
    return next.handle(req);
  }

}
